module.exports = __webpack_public_path__ + "img/lianxi_banner.2394d088.png";